import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { MST3040_R01DetailDto, MST3040_R01Dto, MST3040_R01HeaderDto, MST3040_R01UsageDto } from './Dto_MST3040_R01';
import { MST3040_R01Filter } from "./Store_MST3040_R01";

const baseUrl = `${config.apiUrl}/MST3040_R01`;

const getParams = (filter: Partial<MST3040_R01Filter>, listLength?: number) => {	
	return {
		brandCd: filter.brandCd || '',
		itemGroup: filter.itemGroup || '',
		prntItemcd: filter.prntItemcd || '',
		listLength: listLength || 0
	}
}

export const getMST3040_R01List = async (option: string, params: Partial<MST3040_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<MST3040_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getMST3040_R01AllCount = async (params: Partial<MST3040_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getMST3040_R01DetailList = async (prntItemcd: string) => {
	const url = `${baseUrl}/detail/${prntItemcd}`;

	return await getData<ResponseDto<MST3040_R01DetailDto[]>>(url);
}

export const getMST3040_R01UsageList = async (prntItemcd: string) => {
	const url = `${baseUrl}/usage/${prntItemcd}`;

	return await getData<ResponseDto<MST3040_R01UsageDto[]>>(url);
}

export const postMST3040_R01 = async (data: MST3040_R01DetailDto[]) => {
	const url = `${baseUrl}`;

	return await postData<MST3040_R01DetailDto[], ResponseDto<MST3040_R01Dto[]>>(url, data);
}

export const patchMST3040_R01 = async (data: MST3040_R01DetailDto[]) => {

	const url = `${baseUrl}`;

	return await patchData<MST3040_R01DetailDto[], ResponseDto<MST3040_R01Dto[]>>(url, data);
}

export const deleteMST3040_R01 = async (coordinateCd: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			coordinateCd
		}
	});
}

export const downloadExcel_MST3040_R01 = async (option: string, prntItemcd: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			prntItemcd: prntItemcd
		}
	})
}
export const getPdfBlob_MST3040_R01 = async (itemCd: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { itemCd },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};